module.exports = __webpack_public_path__ + "img/mobile-screen.90face81.png";